<template>
  <div>
    <validation-observer ref="requestServiceObjectForm" v-slot="{}" tag="form">
      <label class="color-gray-7 font-16 font-weight-bold">
        <i class="fas fa-gavel color-red mr-1" />
        Razón de Objeción
      </label>
      <div class="row">
        <div class="col-12 col-md-4 column-left">
          <validation-provider
            v-if="!isReadOnly"
            v-slot="{ errors }"
            name="objectReason"
            rules="required"
          >
            <custom-drop-down
              v-model="reasonSelected"
              custom-error-msg="La razón es requerida."
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              label="Razón:"
              :options="availableReasons"
              placeholder="Seleccione"
              @input="onReasonSelected"
            />
          </validation-provider>
          <div v-else>
            <p class="data-title title mb-0">Razón:</p>
            <p class="font-weight-normal description">
              {{ determination.reasonDescription }}
            </p>
          </div>
        </div>
        <div
          v-if="isReasonObjectedWithAppointmentSelected && !isReadOnly"
          class="col-12 col-md-6"
        >
          <div class="row">
            <div class="col-12 col-md-7">
              <label for="">Número de cita:</label>
              <input
                v-model="appointmentNumber"
                v-mask="'####-######'"
                class="form-control"
                placeholder="Escriba número de cita"
              />
            </div>
            <div class="col-12 col-md-5 align-self-end">
              <action-button
                i="fa fa-search orange-icon"
                text="Buscar"
                variant="success"
                @click="searchAppointment"
              />
            </div>
          </div>
        </div>
        <div v-if="isReadOnly && appointmentId > 0">
          <p class="data-title mb-0 title">Número de Cita:</p>
          <p class="font-weight-normal description">
            {{ formattedAppointmentNumber }}
          </p>
        </div>
        <div
          v-else-if="isThereAuthorizedPositionBySAEESelected && !isReadOnly"
          class="col-12 col-md-4"
        >
          <validation-provider
            v-slot="{ errors }"
            name="positionNumber"
            rules="required"
          >
            <custom-input
              v-model="model.objection.positionNumber"
              custom-error-msg="El número de puesto es requerido."
              :error="errors[0]"
              label="Número de puesto:"
            />
          </validation-provider>
        </div>
        <div
          v-else-if="isIrregularStaffApplicationProcessSelected && !isReadOnly"
          class="col-12 col-md-5"
        >
          <validation-provider
            v-slot="{ errors }"
            name="serviceCenter"
            rules="required"
          >
            <custom-drop-down
              v-model="reasonCategorySelected"
              custom-error-msg="La categoría es requerida."
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              label="Categoría:"
              :options="reasonCategories"
              placeholder="Seleccione"
              @input="onReasonCategorySelected"
            />
          </validation-provider>
        </div>
        <div
          v-if="isReadOnly && isThereAuthorizedPositionBySAEESelectedOnViewMode"
        >
          <p class="data-title mb-0 title">Número de puesto:</p>
          <p class="font-weight-normal description">
            {{ determination.objection.positionNumber }}
          </p>
        </div>
        <div
          v-if="
            isReadOnly && isIrregularStaffApplicationProcessSelectedOnViewMode
          "
        >
          <p class="data-title mb-0 title">Categoría:</p>
          <p class="font-weight-normal description">
            {{ determination.objection.reasonCategoryDescription }}
          </p>
        </div>
      </div>
      <div v-if="showAppointmentInfo">
        <div class="pt-4 mt-3">
          <label class="font-18 d-block font-weight-bold">
            <i class="fas fa-info-circle color-orange mr-1" />
            Información de Cita Coordinada
          </label>
        </div>
        <div class="bg-secondary-3 rounded p-3 mt-3">
          <div class="row mt-0">
            <div class="col-12 col-md-2">
              <span class="data-title d-block">Tipo de Evaluación:</span>
              <span class="font-16 color-black">
                {{ model.objection.evaluationName | empty }}
              </span>
            </div>
            <div class="col-12 col-md-2">
              <span class="data-title d-block">Disciplina:</span>
              <span class="font-16 color-black">
                {{ model.objection.disciplineName | empty }}
              </span>
            </div>
            <div class="col-12 col-md-3">
              <span class="data-title d-block">Proveedor:</span>
              <span class="font-16 color-black">
                {{ model.objection.providerName | empty }}
              </span>
            </div>
            <div class="col-12 col-md-3">
              <span class="data-title d-block">Especialista:</span>
              <span class="font-16 color-black">
                {{ model.objection.specialistName | empty }}
              </span>
            </div>
            <div class="col-12 col-md-2">
              <span class="data-title d-block">Télefono de Contacto:</span>
              <span class="font-16 color-black">
                {{ model.objection.providerPhoneNumber | phone }}
              </span>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-12 col-md-2">
              <span class="data-title d-block">Número de Cita:</span>
              <span class="font-16 color-black">
                {{ appointmentValue | appointment }}
              </span>
            </div>
            <div class="col-12 col-md-2">
              <span class="data-title d-block">Fecha de la Cita:</span>
              <span class="font-16 color-black">
                {{ model.objection.appointmentDate | empty }}
              </span>
            </div>
            <div class="col-12 col-md-3">
              <span class="data-title d-block">Hora de la Cita:</span>
              <span class="font-16 color-black">
                {{ model.objection.appointmentHour | empty }}
              </span>
            </div>
            <div class="col-12 col-md-3">
              <span class="data-title d-block">Dirección:</span>
              <span class="font-16 color-black">
                {{ model.objection.providerAddress | empty }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isReadOnly">
        <AppointmentView
          v-if="appointmentId > 0"
          :data="determination.objection.appointment"
        />
      </div>
      <div class="row">
        <div
          v-if="!isReasonObjectedWithAppointmentSelected"
          class="col-12 mt-3"
        >
          <validation-provider
            v-if="!isReadOnly"
            v-slot="{ errors }"
            name="objectComment"
            rules="required"
          >
            <label class="data-title mb-0">Comentario:</label>
            <custom-text-area
              v-model="model.description"
              :count-classes="['float-right']"
              custom-error-msg="El comentario es requerido."
              :error="errors[0]"
              :maxlength="3000"
              show-char-count
            />
          </validation-provider>
        </div>
        <div v-if="studentAdmissionInfo" class="col-12 d-flex pr-5 pr-md-0">
          <div class="row ml-n2">
            <div
              class="rounded col-12 p-2 ml-2"
              :class="studentReferralBgClass"
            >
              <div class="d-flex align-items-center">
                <em
                  class="fa fa-bell-exclamation pl-2"
                  :class="[studentReferralTextColor, studentReferralIcon]"
                />
                <div
                  class="font-14 font-weight-normal ml-3"
                  :class="studentReferralTextColor"
                >
                  {{ therapyReferralMessage }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="determination.description" class="col-12">
          <p class="header-label title">Comentario:</p>
          <p class="text-label description">
            {{ determination.description }}
          </p>
        </div>
        <div v-if="!isReadOnly" class="col-12 mt-3">
          <div class="d-flex flex-row-reverse bd-highlight w-100 actions">
            <div class="bd-highlight ml-2">
              <action-button
                i="fas fa-save fa-lg"
                text="Guardar"
                variant="success"
                @click="saveObjection"
              />
            </div>
            <div class="mx-0 bd-highlight">
              <action-button
                id="modal-btn-cancelar"
                i="fas fa-times-circle"
                text="Cancelar"
                variant="outline-danger"
                @click="$emit('cancel')"
              />
            </div>
          </div>
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import { mask } from 'ke-the-mask';
import objectToFormData from 'object-to-formdata';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import CustomDropDown from 'custom-drop-down';
import CustomInput from 'CustomInput';
import CustomTextArea from 'CustomTextArea';
import ActionButton from 'ActionButton';
import AppointmentView from './AppointmentView.vue';
import DeterminationReasons from '@/utils/constants/student/determinationReason.js';
import AppointmentStatuses from '@/utils/constants/student/appointmentStatusEnum.js';
import ServiceStatuses from '@/utils/constants/student/provisionalRemedyAnswerStatus.js';
import serviceTypes from '@/utils/constants/rp/serviceTypes.js';
import admissionStatus from '@/utils/constants/pei/referral/admissionStatus.js';
import alert from '@quisit/mipe-utils/mixins/alert.mixin.js';
import {
  saveDetermination,
  getAppointment,
  getReasonCategories,
  getDeterminationRequestService,
  getCheckStudentAdmission as _getCheckStudentAdmission,
} from '@/modules/student-answer-rp/api.js';

export default {
  name: 'RequestServiceObject',
  components: {
    CustomDropDown,
    CustomTextArea,
    CustomInput,
    ActionButton,
    ValidationProvider,
    ValidationObserver,
    AppointmentView,
  },
  directives: {
    mask,
  },
  mixins: [alert],
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      model: {
        description: null,
        objection: {
          appointmentId: null,
          admissionId: null,
          specialistId: null,
          specialistName: null,
          evaluationName: null,
          disciplineName: null,
          appointmentDateTime: null,
          appointmentDate: null,
          appointmentHour: null,
          providerName: null,
          providerMunicipality: null,
          providerAddress: null,
          providerPhoneNumber: null,
          positionNumber: null,
          reasonCategoryId: null,
        },
      },
      appointmentNumber: null,
      appointmentMessage: null,
      reasonSelected: null,
      haveCoordinatedAppointment: false,
      reasonCategorySelected: null,
      reasonCategories: [],
      determination: {
        requestServiceId: null,
        serviceStatusId: null,
        serviceStatusDescription: null,
        reasonDescription: null,
        judgeName: null,
        description: null,
        objection: null,
        document: null,
      },
      studentAdmissionInfo: null,
    };
  },
  async mounted() {
    if (this.isReadOnly) {
      this.getDeterminationRequestService();
    } else {
      if (this.isTherapyService) {
        await this.getCheckStudentAdmission();
      }
    }
  },
  computed: {
    appointmentValue() {
      return this.model.objection?.appointmentId?.toString() || '';
    },
    appointmentId() {
      return this.determination?.objection?.appointment?.appointmentId || 0;
    },
    formattedAppointmentNumber() {
      return `${this.determination?.objection?.appointment?.appointmentId
        ?.toString()
        .substr(
          0,
          4
        )} - ${this.determination?.objection?.appointment?.appointmentId
        ?.toString()
        .substr(4)}`;
    },
    availableReasons() {
      return this.data.reasons.filter((x) => {
        if (
          x.id === DeterminationReasons.ObjectadoReferidoActivoEnAgencia &&
          !this.userHasPermissions(
            'menu.rempro.provider.view.objectedreferredactiveinsaee'
          )
        ) {
          return false;
        } else {
          return true;
        }
      });
    },
    isReasonObjectedWithAppointmentSelected() {
      return this.reasonSelected?.id === DeterminationReasons.ObjetadoConCita;
    },
    isThereAuthorizedPositionBySAEESelected() {
      return (
        this.reasonSelected?.id ===
        DeterminationReasons.ThereAuthorizedPositionBySAEE
      );
    },
    isIrregularStaffApplicationProcessSelected() {
      return (
        this.reasonSelected?.id ===
        DeterminationReasons.IrregularStaffApplicationProcess
      );
    },
    isThereAuthorizedPositionBySAEESelectedOnViewMode() {
      return (
        this.determination.reasonId ===
        DeterminationReasons.ThereAuthorizedPositionBySAEE
      );
    },
    isIrregularStaffApplicationProcessSelectedOnViewMode() {
      return (
        this.determination.reasonId ===
        DeterminationReasons.IrregularStaffApplicationProcess
      );
    },
    showAppointmentInfo() {
      return (
        this.isReasonObjectedWithAppointmentSelected &&
        !this.isReadOnly &&
        this.model.objection?.appointmentId
      );
    },
    isTherapyService() {
      return this.data.serviceTypeId === serviceTypes.Therapy;
    },
    hasReferredAdmittedOrRelatedActiveService() {
      return [
        admissionStatus.Admitido,
        admissionStatus.ServicioRelacionadoActivo,
      ].includes(this.studentAdmissionInfo?.admissionStatusId);
    },
    hasReferredLinkedOrAssigned() {
      return [admissionStatus.Vinculado, admissionStatus.Asignado].includes(
        this.studentAdmissionInfo?.admissionStatusId
      );
    },
    therapyReferralMessage() {
      if (this.hasReferredAdmittedOrRelatedActiveService)
        return `El servicio ${this.data.serviceDiscipline} cuenta con un referido ${this.studentAdmissionInfo?.referralNumber} en estatus ${this.studentAdmissionInfo?.admissionStatus} en SAEE.`;

      if (this.hasReferredLinkedOrAssigned)
        return `El servicio ${this.data.serviceDiscipline} cuenta con un referido ${this.studentAdmissionInfo?.referralNumber} en SAEE.`;

      return '';
    },
    studentReferralBgClass() {
      return this.hasReferredAdmittedOrRelatedActiveService
        ? 'bg-secondary-19'
        : 'bg-secondary-41';
    },
    studentReferralTextColor() {
      return this.hasReferredAdmittedOrRelatedActiveService
        ? 'color-secondary-20'
        : 'color-secondary-40';
    },
    studentReferralIcon() {
      return this.hasReferredAdmittedOrRelatedActiveService
        ? 'fas fa-exclamation-circle'
        : 'fa fa-bell-exclamation';
    },
  },
  methods: {
    async onReasonSelected(item) {
      if (!item) {
        this.model.objection = {
          appointmentId: null,
          admissionId: null,
          specialistId: null,
          specialistName: null,
          evaluationName: null,
          disciplineName: null,
          appointmentDateTime: null,
          appointmentDate: null,
          appointmentHour: null,
          providerName: null,
          providerMunicipality: null,
          providerAddress: null,
          providerPhoneNumber: null,
          positionNumber: null,
          reasonCategoryId: null,
        };
        this.reasonCategorySelected = null;
        this.reasonCategories = [];
        return;
      }

      if (!this.isThereAuthorizedPositionBySAEESelected)
        this.model.objection.positionNumber = null;

      if (this.isIrregularStaffApplicationProcessSelected) {
        if (!this.reasonCategories.length) {
          const { data } = await getReasonCategories(item.id);
          this.reasonCategories = data;
        }
      } else {
        this.reasonCategorySelected = null;
        this.model.objection.reasonCategoryId = null;
      }
    },
    async saveObjection() {
      const isFormValid = await this.$refs.requestServiceObjectForm.validate();
      if (!isFormValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información de objeción solicitada.',
          'error'
        );
        return;
      }

      if (
        this.isReasonObjectedWithAppointmentSelected &&
        !this.model.objection.appointmentId
      ) {
        this.ShowToast('Alerta', 'Favor escriba el número de cita.', 'error');
        return;
      }
      const answer = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea Objetar el servicio ${this.data.serviceDiscipline}?`,
        'Sí',
        'No'
      );
      if (!answer) return;

      const payload = objectToFormData(
        {
          requestServiceId: this.data.requestServiceId,
          serviceStatusId: ServiceStatuses.Objetado,
          reasonId: this.reasonSelected.id,
          ...this.model,
        },
        { indices: true, nullsAsUndefineds: true }
      );

      const { data } = await saveDetermination(payload).catch((error) => {
        this.ShowToast('Alerta', `${error.message}.`, 'error');
        return { data: false };
      });
      this.ShowToast(
        `Confirmación`,
        'El servicio ha sido objetado exitosamente.',
        'success'
      );
      this.$emit('save', data);
    },
    async searchAppointment() {
      if (!this.appointmentNumber) {
        this.ShowToast('Alerta', 'Favor escriba el número de cita.', 'error');
        return;
      }

      const { data } = await getAppointment({
        appointmentId: this.appointmentNumber.replace('-', ''),
      });

      if (!data) {
        this.ShowToast('Alerta', 'El número de cita no existe.', 'error');
        return;
      }
      if (data.studentSieId != this.data.studentSieId) {
        this.ShowToast(
          'Alerta',
          'El número de cita no coincide con el número de SIE del estudiante.',
          'error'
        );
        return;
      }
      if (data.disciplineTypeId != this.data.disciplineTypeId) {
        this.ShowToast(
          'Alerta',
          'El número de cita no coincide con la disciplina del servicio solicitado.',
          'error'
        );
        return;
      }
      if (data.appointmentStatusId != AppointmentStatuses.coordinated) {
        this.ShowToast(
          'Alerta',
          'El número de cita no se encuentra en estatus coordinada.',
          'error'
        );
        return;
      }
      this.model.objection = { ...this.model.objection, ...data };
      if (this.model.objection?.appointmentId) {
        this.model.objection.appointmentDate = this.$options.filters.date(
          this.model.objection.appointmentDateTime
        );
        this.model.objection.appointmentHour = this.$options.filters.hour(
          this.model.objection.appointmentDateTime
        );
      }
    },
    onReasonCategorySelected(item) {
      this.model.objection.reasonCategoryId = item?.id;
    },
    async getDeterminationRequestService() {
      const { data } = await getDeterminationRequestService(
        this.data.requestServiceId
      ).catch((error) => {
        this.ShowToast('Alerta', `${error.message}.`, 'error');
        return { data: false };
      });

      if (data) {
        this.determination = data;
      }
    },
    async getCheckStudentAdmission() {
      const serviceData = this.data;
      this.studentAdmissionInfo = (
        await _getCheckStudentAdmission(
          serviceData.academicYearId,
          serviceData.studentSieId,
          serviceData.disciplineTypeId
        )
      ).data;
    },
  },
  watch: {
    isReadOnly(newValue) {
      if (newValue) {
        this.getDeterminationRequestService();
      }
    },
  },
};
</script>
<style scoped lang="scss">
.column-left {
  max-width: 481.7px !important;
}
.title {
  font-size: 14px;
}
.description {
  font-size: 16px;
}
</style>
